import React, {useState, useEffect, useContext} from 'react';
import {
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Button,
    InputGroup,
    Input,
    FormGroup,
    Label,
    CustomInput,
} from 'reactstrap';
import {addUser} from 'utils/api';
import {toast} from 'react-toastify';
import {connect} from 'react-redux';
import {ErrorContext} from 'contexts/ErrorContext';
import InputWithError from 'components/InputWithError';
import SpinnerButton from 'components/SpinnerButton';

const AddUserModal = ({isOpen, toggle, user, updateListAfterEdit, auth, refreshList}) => {
    const {handleErrors} = useContext(ErrorContext);

    const [submitting, setSubmitting] = useState(false);
    const [isEmailEditingOpen, setIsEmailEditingOpen] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    // const [userData, setUserData] = useState({
    //     name: '',
    //     email: '',
    //     isAdministrator: false,
    // });
    const [error, setError] = useState(null);

    const onConfirm = async() => {
        try {
            setSubmitting(true);
            const params = {
                name,
                email: newEmail.trim() ? newEmail : email,
                isAdministrator: isAdmin,
            };
            let newUser = await addUser(params);
            refreshList(true);
            toast.success('User successfully added');
            toggle();
        } catch(err) {
            setSubmitting(false);
            // if(err.message && err.message.length < 150) {
            //     toast.error(err.message);
            // }
            handleErrors(err, setError);
            console.log(err);
            // throw err;
        }
    };

    // const editField = (value, fieldName) => {
    //     let userDataClone = { ...userData };
    //     userDataClone[fieldName] = value;
    //     setUserData(userDataClone);
    // }

    const toggleCheckbox = () => setIsAdmin(prevState => !prevState);

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <strong>Add User</strong>
            </ModalHeader>
            <ModalBody>
                <InputWithError
                    placeholder="Full name"
                    name="name"
                    value={name}
                    type="text"
                    disableAutoComplete
                    onChange={setName}
                    errorObj={error}
                    prependIcon={<i className="fas fa-user"/>}
                    marginBottomClass="mb-3"
                />
                <InputWithError
                    placeholder="Email"
                    name="email"
                    value={email}
                    type="email"
                    onChange={setEmail}
                    errorObj={error}
                    // disabled
                    prependIcon={<i className="fas fa-at"/>}
                    marginBottomClass="mb-3"
                />
                <div className="d-flex align-items-center mb-2">
                    {/*<InputGroup>*/}
                    {/*    <Input*/}
                    {/*        type="checkbox"*/}
                    {/*        value={isAdmin}*/}
                    {/*        checked={isAdmin}*/}
                    {/*        onChange={toggleCheckbox}*/}
                    {/*        style={{position: 'static', margin: '0'}}*/}
                    {/*        disabled={auth.username === email}*/}
                    {/*    />*/}
                    {/*    <div style={{marginLeft: '5px'}}>*/}
                    {/*        Administrator*/}
                    {/*    </div>*/}
                    {/*</InputGroup>*/}
                    <FormGroup className="custom-form-checkbox" check style={{marginRight: '1.5rem'}}>
                        {/*<Label check>*/}
                        {/*    <Input*/}
                        {/*        type="checkbox"*/}
                        {/*        name="isAdmin"*/}
                        {/*        checked={isAdmin}*/}
                        {/*        onChange={toggleCheckbox}*/}
                        {/*    />{' '}*/}
                        {/*    Administrator*/}
                        {/*</Label>*/}
                        <CustomInput
                            inline
                            type="checkbox"
                            name="isAdmin"
                            label="Administrator"
                            id="admin-checkbox"
                            onChange={toggleCheckbox}
                            checked={isAdmin}
                        />
                    </FormGroup>
                </div>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    minWidth="85px"
                    submitting={submitting}
                    onClick={onConfirm}
                    title="Submit"
                />
                {/*<Button*/}
                {/*    className="calltoaction-button"*/}
                {/*    style={{minWidth: '85px'}}*/}
                {/*    onClick={onConfirm}*/}
                {/*    // disabled={!inputValue.trim() || previewLoading}*/}
                {/*>*/}
                {/*    {creationLoading ?*/}
                {/*        <div className="flex-centered">*/}
                {/*            <i className="fa fa-spinner fa-spin"/>*/}
                {/*        </div>*/}
                {/*        :*/}
                {/*        <>Submit</>*/}
                {/*    }*/}
                {/*</Button>*/}
            </ModalFooter>
        </Modal>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(AddUserModal);


// import React, {useState} from 'react';
// import {Modal, ModalBody, ModalHeader, ModalFooter, Button, InputGroup, Input} from 'reactstrap';
// import {addUser} from 'utils/api';
// import {toast} from 'react-toastify';
//
// const AddUserModal = ({isOpen, toggle, getUsersList}) => {
//     const [creationLoading, setCreationLoading] = useState(false);
//     const [userData, setUserData] = useState({
//         name: '',
//         email: '',
//         isAdministrator: false,
//     });
//
//     const onConfirm = async() => {
//         try {
//             setCreationLoading(true);
//             const params = {
//                 name: userData.name,
//                 email: userData.email,
//                 isAdministrator: userData.isAdministrator,
//             };
//             await addUser(params);
//             getUsersList();
//             toggle();
//             toast.success('User successfully added');
//         } catch(err) {
//             setCreationLoading(false);
//             console.log(err);
//             if(
//                 err.errors &&
//                 err.errors.email &&
//                 err.errors.email.length
//             ) {
//                 err.errors.email[0].code === 'NOT_UNIQUE_ERROR' ? toast.error('This email is already in use') : toast.error('Invalid email address')
//             } else if(err.message && err.message.length < 150) {
//                 toast.error(err.message);
//             }
//             throw err;
//         }
//     };
//
//     const editField = (value, fieldName) => {
//         let userDataClone = {...userData};
//         userDataClone[fieldName] = value;
//         setUserData(userDataClone);
//     };
//
//     const toggleCheckbox = () => {
//         let userDataClone = {...userData};
//         userDataClone.isAdministrator = !userDataClone.isAdministrator;
//         setUserData(userDataClone);
//     };
//
//     return (
//         <Modal isOpen={isOpen}>
//             <ModalHeader toggle={toggle}>
//                 <strong>Add user</strong>
//             </ModalHeader>
//             <ModalBody>
//                 <InputGroup className="user-edit-input_group">
//                     <div className="input-group-prepend">
//                         <span style={{width: '40px'}} className="input-group-text">
//                             <i className="fas fa-user"/>
//                         </span>
//                     </div>
//                     <Input
//                         type="text"
//                         placeholder="Full name"
//                         value={userData.name}
//                         onChange={(e) => editField(e.target.value, 'name')}
//                     />
//                 </InputGroup>
//                 <InputGroup className="user-edit-input_group">
//                     <div className="input-group-prepend">
//                         <span style={{width: '40px'}} className="input-group-text">
//                             <i className="fas fa-at"/>
//                         </span>
//                     </div>
//                     <Input
//                         type="email"
//                         placeholder="E-mail"
//                         value={userData.email}
//                         onChange={(e) => editField(e.target.value, 'email')}
//                     />
//                 </InputGroup>
//                 <InputGroup className="user-edit-input_group" style={{alignItems: 'center'}}>
//                     <Input
//                         type="checkbox"
//                         value={userData.isAdministrator}
//                         checked={userData.isAdministrator}
//                         onChange={(e) => toggleCheckbox()}
//                         style={{position: 'static', margin: '0'}}
//                     />
//                     <div style={{marginLeft: '5px'}}>
//                         Administrator
//                     </div>
//                 </InputGroup>
//             </ModalBody>
//             <ModalFooter className="select-fetches-modal-footer">
//                 <Button style={{color: 'white'}} onClick={toggle}>
//                     Cancel
//                 </Button>
//                 {creationLoading ?
//                     <div className="flex-centered" style={{width: '85px', height: '100%'}}>
//                         <i className="fa fa-spinner fa-spin"/>
//                     </div>
//                     :
//                     <Button
//                         style={{minWidth: '85px'}}
//                         onClick={onConfirm}
//                         className="calltoaction-button"
//                         disabled={!userData.name.trim()}
//                     >
//                         Add
//                     </Button>
//                 }
//             </ModalFooter>
//         </Modal>
//     );
// };
//
// export default AddUserModal;